import { Currency } from 'ha/constants/Currencies';
import { Language } from 'ha/i18n';
import { ListingsSummary } from 'ha/services/apiV2/types/ListingsSummary';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface Query {
  userId: number | null;
  withHidden: boolean;
  minPrice?: number;
  maxPrice?: number;
  currency?: Currency;
  from?: string;
  to?: string;
  lang?: Language;
}

export type GetListingsSummaryCall = (
  data: Query,
) => Promise<{ data: ListingsSummary }>;

export default (makeCall: MakeCall) => ({
  userId,
  withHidden,
  minPrice,
  maxPrice,
  currency,
  from,
  to,
  lang,
}: Query) =>
  makeCall<ListingsSummary>('GET', `/api/v2/listings/summary`, {
    query: {
      userId,
      withHidden,
      minPrice,
      maxPrice,
      currency,
      from,
      to,
      lang,
    },
  });
